import { Routes } from '@angular/router';
import { RequestGuard } from '../auth/request-permission.guard';
import { environment } from '../../environments/environment';

export const ViewRoutes: Routes = [
    {
        path: 'ibs-requests',
        canActivate: [RequestGuard],
        loadComponent: () => import('./requests/request-listing/ibs-request-listing/ibs-request-listing.component').then(m => m.IbsRequestListingComponent),

    },
    {
        path: 'tower-requests',
        canActivate: [RequestGuard],
        loadComponent: () => import('./requests/request-listing/tower-request-listing/tower-request-listing.component').then(m => m.TowerRequestListingComponent),

    },
    {
        path: 'ibs-requests/detail/:id',
        canActivate: [RequestGuard],
        loadComponent: () => import('./requests/ibs-request-details/ibs-request-details.component').then(m => m.IbsRequestDetailsComponent),
   
    },
    {
        path: 'ibs-requests/etimad-detail/:id',
        canActivate: [RequestGuard],
        loadComponent: () => import('./requests/etimad-rfp-request-details/etimad-rfp-request-details.component').then(m => m.EtimadRfpRequestDetailsComponent),
    },
    {
        path: 'tower-requests/detail/:id',
        canActivate: [RequestGuard],
        loadComponent: () => import('./requests/tower-request-details/tower-request-details.component').then(m => m.TowerRequestDetailsComponent),

    },
    {
        path: 'roles',
        loadComponent: () => import('./role-management/roles-listing/roles-listing.component').then(m => m.RolesListingComponent),
    },
    {
        path: 'roles/view/:roleId',
        data: { mode: 'view' },
        loadComponent: () => import('./role-management/role-crud/role-crud.component').then(m => m.RoleCrudComponent),
    },
    {
        path: 'roles/create',
        data: { mode: 'create' },
        loadComponent: () => import('./role-management/role-crud/role-crud.component').then(m => m.RoleCrudComponent),
    },
    {
        path: 'roles/edit/:roleId',
        data: { mode: 'edit' },
        loadComponent: () => import('./role-management/role-crud/role-crud.component').then(m => m.RoleCrudComponent),
    },
   
    {
        path: 'users',
        loadComponent: () => import('./user-management/users-listing/users-listing.component').then(m => m.UsersListingComponent),
    },
    {
        path: 'users/create',
        data: { mode: 'create' },
        loadComponent: () => import('./user-management/user-crud/user-crud.component').then(m => m.UserCrudComponent),
    },
    {
        path: 'users/view/:userId',
        data: { mode: 'view' },
        loadComponent: () => import('./user-management/user-crud/user-crud.component').then(m => m.UserCrudComponent),
    },
    {
        path: 'users/edit/:userId',
        data: { mode: 'edit' },
        loadComponent: () => import('./user-management/user-crud/user-crud.component').then(m => m.UserCrudComponent),
    },
    {
        path: 'settings',
        loadComponent: () => import('../../../../abraj-shared/src/lib/components/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent),
    },
    {
        path: 'profile',
        loadComponent: () => import('../../../../abraj-shared/src/lib/components/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent),
    },
    {
        path: 'support',
        loadComponent: () => import('../../../../abraj-shared/src/lib/components/coming-soon/coming-soon.component').then(m => m.ComingSoonComponent),
    },
    {
        path: 'payments',
        loadComponent: () => import('../../../../abraj-shared/src/lib/components/payment-screen/payment-screen.component').then(m => m.PaymentScreenComponent),
    },
    {
        path: 'contracts',
        canActivate: [RequestGuard],
        loadComponent: () => import('./contract-listing-mno/contract-listing-mno.component').then(m => m.ContractListingMnoComponent),
    },
    {
        path: 'contracts/renew/:contractId',
        canActivate: [RequestGuard],
        data: { userType: 'nhp', environment },
        loadComponent: () => import('../../../../abraj-shared/src/lib/components/renew-contract-details/renew-contract-details.component').then(m => m.RenewContractDetailsComponent),
    },
    // {
    //     path: 'dashboard',
    //     loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    // },
    
     {
        path: '',
        redirectTo: 'ibs-requests',
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'ibs-requests',
    }
]